<template>
  <v-app class="ade-app">
    <v-app-bar v-if="showAppBar" app color="secondary" dark>
      <div class="d-flex align-center">
        <v-img src="@/assets/adequation-logo.svg" />
      </div>

      <v-tabs align-with-title background-color="transparent">
        <v-tab to="/" exact>{{ $t("Utilisateurs") }}</v-tab>
        <v-tab to="/societes" exact>{{ $t("Sociétés") }}</v-tab>
        <v-tab to="/exports" exact>{{ $t("Exports") }}</v-tab>
        <v-tab v-if="hasAdminRights" to="/notifications">
          {{ $t("Notifications") }}
          <v-badge
            v-if="notificationBadgeCount > 0"
            color="error"
            :content="notificationBadgeCount"
            inline
          ></v-badge>
          <v-badge
            v-else-if="notificationBadgeCount == 0"
            color="primary"
            content="0"
            inline
          ></v-badge>
        </v-tab>
      </v-tabs>
      <v-spacer></v-spacer>
      <v-menu left bottom offset-y>
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            {{ `${user.prenom} ${user.nom}` }}
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="logout()">
            <v-list-item-title>{{ $t("Déconnexion") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-progress-linear
      absolute
      :active="false"
      indeterminate
      class="app-progress-bar"
    />

    <v-content>
      <v-container fluid class="main-container">
        <router-view />
        <!-- component matched by the route will render here -->
      </v-container>
    </v-content>

    <v-snackbar
      v-model="snackbar"
      :color="snackbarType"
      bottom
      :timeout="snackbarTimeout"
    >
      <div v-html="snackbarMessage"></div>
      <v-btn text @click="snackbar = false">
        {{ $t("Fermer") }}
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { LOGOUT, GET_NOTIFICATION_BADGE } from "@/store/action-types";
import { mapAppFields } from "@/store/modules/app";
const {
  mapState: mapAuthState,
  mapActions: mapAuthActions
} = createNamespacedHelpers("auth");
const { mapGetters: mapAuthGetters } = createNamespacedHelpers(`auth`);
const {
  mapActions: mapNotificationsActions,
  mapState: mapNotificationsState
} = createNamespacedHelpers(`notifications`);

export default {
  name: "App",
  computed: {
    ...mapAuthGetters(["hasAdminRights"]),
    ...mapAuthState(["user"]),
    ...mapAppFields([
      "snackbar",
      "snackbarMessage",
      "snackbarType",
      "snackbarTimeout"
    ]),
    showAppBar() {
      return this.$store.getters["auth/isLoggedIn"];
    },
    ...mapNotificationsState(["notificationBadgeCount"])
  },
  methods: {
    ...mapAuthActions({
      logout: LOGOUT
    }),
    ...mapNotificationsActions({
      getNotificationBadge: GET_NOTIFICATION_BADGE
    })
  },
  watch: {
    showAppBar(value) {
      if (value) {
        this.getNotificationBadge();
      }
    }
  },
  beforeMount() {
    if (this.$store.getters["auth/isLoggedIn"]) this.getNotificationBadge();
  }
};
</script>

<style lang="scss">
html {
  overflow-y: hidden !important; //cacher le scroll vertical inutile
}

.ade-app {
  font-weight: 300;
}

.main-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.app-progress-bar {
  z-index: 99999;
}

/** EDIT FORMS */

.ade-forms-edit {
  height: 100%;
  display: flex;
  flex-direction: column;

  &__fields-wrapper {
    flex: 1 1 auto;
  }

  &__small-text-overflow {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

.v-expansion-panel.top-level-extansion-panel {
  .v-expansion-panel {
    &::before {
      box-shadow: none;
    }
  }

  > .v-expansion-panel-content {
    .col {
      padding-left: 24px;
      padding-right: 24px;
    }

    > .v-expansion-panel-content__wrap {
      padding-left: 0;
      padding-right: 0;
    }
  }
}

.v-expansion-panel-header[disabled] {
  .v-expansion-panel-header__icon {
    opacity: 0.3;
  }
}

.v-select.no-icon-rotation.v-select--is-menu-active
  .v-input__icon--append
  .v-icon {
  transform: none;
}

.ade-forms-edit-footer {
  background: #fff;
  position: sticky;
  bottom: 0;
  z-index: 9999;
  width: 100%;
}
</style>
